// src/pages/employer/OrgSettings.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { orgAPI } from '../../services/api';
import toast from 'react-hot-toast';

export const OrgSettings = () => {
  const { activeOrg, refreshOrgs } = useAuth();
  const [form, setForm] = useState({ name: '', shortName: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (activeOrg) {
      setForm({
        name:      activeOrg.name      || '',
        shortName: activeOrg.shortName || '',
      });
    }
  }, [activeOrg]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await orgAPI.update(activeOrg.id, {
        name:      form.name.trim(),
        shortName: form.shortName.trim() || null,
      });
      await refreshOrgs();
      toast.success('Organisation updated');
    } catch {
      // Axios interceptor shows error toast
    } finally {
      setSaving(false);
    }
  };

  if (!activeOrg) return null;

  return (
    <div>
      <div className="page-header">
        <h1>Organisation Settings</h1>
      </div>

      <div className="page-content" style={{ marginTop: 24 }}>
        <div className="section-box">
          <div className="section-box-header">Organisation Details</div>
          <div className="section-box-body">
            <form onSubmit={handleSubmit}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div>
                  <label className="form-label">Organisation Name</label>
                  <input
                    className="form-input"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div>
                  <label className="form-label">Short Name / Acronym</label>
                  <input
                    className="form-input"
                    name="shortName"
                    value={form.shortName}
                    onChange={handleChange}
                    placeholder="e.g. ACME, IBM"
                  />
                  <p style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
                    Optional abbreviation shown in compact views.
                  </p>
                </div>

                <div style={{ paddingTop: 8 }}>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={saving || !form.name.trim()}
                  >
                    {saving ? 'Saving…' : 'Save Changes'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
